import { TERMINAL_TRIP_STATE_CODES } from "./realtime_contract"

export function tripRemoteGone(status) {
  return Number(status) === 404
}

// Trip-state codes the API returns (HTTP 422, mirroring TripRecordingStatus on
// the server) when points/presence hit a trip that is no longer recording —
// finished explicitly, superseded by a newer trip, or abandoned. These are
// terminal for the web tracker: stop recording instead of retrying forever.
const TERMINAL_TRIP_STATE_CODE_SET = new Set(TERMINAL_TRIP_STATE_CODES)

export function tripStateTerminal(code) {
  if (code == null || code === "") return false
  return TERMINAL_TRIP_STATE_CODE_SET.has(String(code))
}

// Best-effort { code } extraction from an error response body; null when the
// body isn't JSON or carries no code. Consumes the body — call only on
// responses you've already decided not to use otherwise.
export async function responseErrorCode(res) {
  try {
    const body = await res.json()
    return body?.code != null ? String(body.code) : null
  } catch {
    return null
  }
}
